export enum TableSortDirection {
    Asc = 'asc',
    Desc = 'desc',
}

export enum DiagnosticRatingSortValue {
    GOOD = 4,
    AVERAGE = 3,
    BAD = 2,
    VERY_BAD = 1,
}
